import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  readonly #scriptSources: Script[] = [
    {
      name: 'google.places',
      src: 'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCnWKM3xggIeTR0Yqx2EXiamkoMZU0dk8s',
      id: 'gp',
    },
    {
      name: 'aws.waf.challenge.p1',
      src: 'https://631aff024b8f.edge.sdk.awswaf.com/631aff024b8f/d46d2daf898e/challenge.js',
      id: 'waf',
    },
    {
      name: 'aws.waf.challenge.t5',
      src: 'https://80526ae6943c.edge.sdk.awswaf.com/80526ae6943c/e1ac31e7726d/challenge.js',
      id: 'waf',
    },
    {
      name: 'aws.waf.challenge.t6',
      src: 'https://80526ae6943c.edge.sdk.awswaf.com/80526ae6943c/bb04f9bca3aa/challenge.js',
      id: 'waf',
    },
  ];

  readonly #scripts = {};

  constructor() {
    this.#scriptSources.forEach((script: Script) => {
      this.#scripts[script.name] = {
        loaded: false,
        src: script.src,
        id: script.id,
      };
    });
  }

  public loadScript(name: string): Promise<ScriptResponse> {
    return new Promise((resolve) => {
      if (!this.#scripts[name]) {
        resolve({ script: name, loaded: false, status: 'No script' });
      }
      // resolve if already loaded
      if (this.#scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.#scripts[name].src;
        script.id = this.#scripts[name].id;
        script.onload = () => {
          this.#scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
        // finally append the script tag in the DOM
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}

export type ScriptResponse = { script: string; loaded: boolean; status: string };
type Script = { name: string; src: string; id: string };
